import { CameraOffState } from "store/states/CameraOffState"
import { CouponCodeState } from "store/states/CouponCodeState"

export const buildUrlWithParams = (
  url: string,
  couponCode: CouponCodeState["couponCode"],
  cameraOff: CameraOffState["cameraOff"]
) => {
  const params = new URLSearchParams()
  if (couponCode) params.append("code", couponCode)
  if (cameraOff) params.append("camera", "off")

  return {
    pathname: url,
    search: params.toString() ? `?${params.toString()}` : ""
  }
}
